module.exports = __webpack_public_path__ + "bc7c870b327b22fcf37d53a46bece75d.svg";